import state from "./state";
import mutations from "./mutations";

export default {
  state: state,
  mutations: mutations,
  getters: {},
  actions: {}
};
